import { Component, OnInit, Inject, EventEmitter, ViewChild, Input, Output, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

declare const window;
declare const document;

@Component({
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrls: ['./image-cropper-dialog.component.scss']
})
export class ImageCropperDialogComponent implements OnInit {

  @ViewChild('container', { static: true }) containerRef;
  @ViewChild('wrapper', { static: true }) wrapperRef;
  @ViewChild('target', { static: true }) targetRef;
  @ViewChild('image', { static: true }) imageRef;
  @ViewChild('canvas', { static: true }) canvasRef;
  sourceX;
  sourceY;
  mousedown;
  initialImageWidth;
  initialImageHeight;
  imageOffsetX;
  imageOffsetY;
  temporalImageOffsetX;
  temporalImageOffsetY;
  zoom;
  ratio;

  constructor(private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ImageCropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.init();
  }

  @HostListener('window:mouseup', ['$event'])
  public onmouseup(e) {
    this.mousedown = false;
    this.imageOffsetX = this.temporalImageOffsetX;
    this.imageOffsetY = this.temporalImageOffsetY;
  }

  @HostListener('window:mousemove', ['$event'])
  public movingMouse(e) {
    if (this.mousedown) {
      if (((this.temporalImageOffsetX + e['movementX']) * (-1) >= 0) && ((this.temporalImageOffsetX + e['movementX']) * (-1) <= (this.imageRef.nativeElement.width - this.wrapperRef.nativeElement.offsetWidth))) {
        this.temporalImageOffsetX = this.temporalImageOffsetX + e['movementX'];
        this.imageRef.nativeElement.style.left = this.temporalImageOffsetX + 'px';
      }
      if (((this.temporalImageOffsetY + e['movementY']) * (-1) >= 0) && ((this.temporalImageOffsetY + e['movementY']) * (-1) <= (this.imageRef.nativeElement.height - this.wrapperRef.nativeElement.offsetHeight))) {
        this.imageRef.nativeElement.style.top = this.temporalImageOffsetY + 'px';
        this.temporalImageOffsetY = this.temporalImageOffsetY + e['movementY'];
      }
    }
  }

  public onmousedown(e) {
    this.mousedown = true;
  }

  public onsliderchange(e) {
    this.zoom = e['value'] / 100;
    this.imageRef.nativeElement.width = this.initialImageWidth * this.zoom;
    this.imageRef.nativeElement.height = this.initialImageHeight * this.zoom;
    const verticalOffsetError = (this.wrapperRef.nativeElement.offsetTop + this.wrapperRef.nativeElement.offsetHeight) - (this.wrapperRef.nativeElement.offsetTop + this.imageRef.nativeElement.offsetTop + this.imageRef.nativeElement.offsetHeight);
    const horizontalOffsetError = (this.wrapperRef.nativeElement.offsetLeft + this.wrapperRef.nativeElement.offsetWidth) - (this.wrapperRef.nativeElement.offsetHeight + this.imageRef.nativeElement.offsetLeft + this.imageRef.nativeElement.offsetWidth);
    if (verticalOffsetError > 0) {
      const oldTop = this.imageRef.nativeElement.offsetTop;
      this.imageRef.nativeElement.style.top = (this.imageRef.nativeElement.offsetTop + verticalOffsetError) + 'px';
      this.temporalImageOffsetY = (this.imageRef.nativeElement.offsetTop - oldTop) * (-1);
    }
  }

  public init() {
    this.mousedown = false;
    this.imageOffsetX = 0;
    this.imageOffsetY = 0;
    this.temporalImageOffsetX = 0;
    this.temporalImageOffsetY = 0;
    this.zoom = 1;
    this.ratio = this.imageRef.nativeElement.naturalWidth / this.imageRef.nativeElement.width;
    this.setContainerSize();
    this.setWrapperSize();
    this.setTargetSize();
  }

  public initImageSize() {
    if ((this.wrapperRef.nativeElement.offsetWidth > this.imageRef.nativeElement.width) && (this.wrapperRef.nativeElement.offsetHeight > this.imageRef.nativeElement.height)) {
      const auxRatio = this.imageRef.nativeElement.naturalWidth / this.imageRef.nativeElement.naturalHeight;
      this.imageRef.nativeElement.height = this.wrapperRef.nativeElement.offsetHeight;
      this.imageRef.nativeElement.width = this.imageRef.nativeElement.height * auxRatio;
      if (this.wrapperRef.nativeElement.offsetWidth > this.imageRef.nativeElement.width) {
        this.imageRef.nativeElement.width = this.wrapperRef.nativeElement.offsetWidth;
        this.imageRef.nativeElement.height = this.imageRef.nativeElement.width / auxRatio;
      }
    } else if (this.wrapperRef.nativeElement.offsetWidth > this.imageRef.nativeElement.width) {
      this.imageRef.nativeElement.width = this.wrapperRef.nativeElement.offsetWidth;
    } else if (this.wrapperRef.nativeElement.offsetHeight > this.imageRef.nativeElement.height) {
      this.imageRef.nativeElement.height = this.wrapperRef.nativeElement.offsetHeight;
    } else {
      this.imageRef.nativeElement.width = this.wrapperRef.nativeElement.offsetWidth;
      if (this.wrapperRef.nativeElement.offsetHeight > this.imageRef.nativeElement.height) {
        const auxRatio = this.wrapperRef.nativeElement.offsetHeight / this.imageRef.nativeElement.height;
        this.imageRef.nativeElement.height = this.wrapperRef.nativeElement.offsetHeight;
        this.imageRef.nativeElement.width = this.imageRef.nativeElement.width * auxRatio;
      }
    }
    this.initialImageWidth = this.imageRef.nativeElement.width;
    this.initialImageHeight = this.imageRef.nativeElement.height;
    this.ratio = this.imageRef.nativeElement.naturalWidth / this.imageRef.nativeElement.width;
  }

  public setContainerSize() {
    this.containerRef.nativeElement.style.width = window.innerWidth / 3;
    this.containerRef.nativeElement.style.paddingTop = window.innerWidth / 20 + 'px';
    this.containerRef.nativeElement.style.paddingBottom = window.innerWidth / 20 + 'px';
    this.containerRef.nativeElement.style.paddingLeft = window.innerWidth / 10 + 'px';
    this.containerRef.nativeElement.style.paddingRight = window.innerWidth / 10 + 'px';
  }

  public setWrapperSize() {
    this.wrapperRef.nativeElement.style.width = this.data['width'] + 'px';
    this.wrapperRef.nativeElement.style.height = this.data['height'] + 'px';
    while (this.wrapperRef.nativeElement.offsetWidth > (this.containerRef.nativeElement.offsetWidth - (window.innerWidth / 10 + window.innerWidth / 10))) {
      this.wrapperRef.nativeElement.style.width = (this.wrapperRef.nativeElement.offsetWidth * 0.9) + 'px';
    }
    this.wrapperRef.nativeElement.style.height = (this.wrapperRef.nativeElement.offsetWidth * this.data['height'] / this.data['width']) + 'px';
  }

  public setTargetSize() {
    this.targetRef.nativeElement.style.top = window.innerWidth / 20 + 'px';
    this.targetRef.nativeElement.style.width = this.wrapperRef.nativeElement.style.width;
    this.targetRef.nativeElement.style.height = this.wrapperRef.nativeElement.style.height;
  }

  public crop() {
    const canvas = <HTMLCanvasElement>this.canvasRef.nativeElement;
    const context = canvas.getContext('2d');
    this.canvasRef.nativeElement.width = this.data.width;
    this.canvasRef.nativeElement.height = this.data.height;
    const imageObj = new Image();
    imageObj.crossOrigin = '*';

    const sourceX = this.imageOffsetX >= 0 ? this.imageOffsetX : this.imageOffsetX * (-1);
    const sourceY = this.imageOffsetY >= 0 ? this.imageOffsetY : this.imageOffsetY * (-1);
    const sourceWidth = this.wrapperRef.nativeElement.offsetWidth;
    const sourceHeight = this.wrapperRef.nativeElement.offsetHeight;
    const destinyX = 0;
    const destinyY = 0;
    const destinyWidth = this.data.width;
    const destinyHeight = this.data.height;

    imageObj.onload = () => {
      context.drawImage(imageObj, sourceX * this.ratio / this.zoom, sourceY * this.ratio / this.zoom, sourceWidth * this.ratio / this.zoom, sourceHeight * this.ratio / this.zoom, destinyX, destinyY, destinyWidth, destinyHeight);
      this.save(canvas);
    };
    imageObj.src = this.data['image'];
  }

  public save(canvas) {
    // const image = canvas.toDataURL('image/png', 1.0).replace('image/png', 'image/octet-stream');
    const image = canvas.toDataURL('image/png', 1.0);
    // const link = document.createElement('a');
    // link.download = 'my-image.png';
    // link.href = image;
    // link.click();
    this.dialogRef.close(image);
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public getThumbnail() {
    return this.data['image'];
  }
}
